/*----- Start Update Image Banner Heading on Home Page -----*/
function updateImageBannerText() {
    console.log('Starting updateImageBannerText function.');
    const imageBannerHeading = document.getElementsByClassName("banner__heading")[0];
    imageBannerHeading.innerHTML = "<span style='color:#ffffff;'>It's Amazing!<br>Taste and See<sup style='font-size:1rem;'>TM</sup>...</span>";
}
/*----- End Update Image Banner Heading on Home Page -----*/

/*----- Start Add Link to Amazing Cookies Img in Footer -----*/
function wrapFooterImages(href) {
  // Select all elements with the class
  const wrappers = document.querySelectorAll('.footer-block__image-wrapper');

  wrappers.forEach(wrapper => {
    const firstChild = wrapper.firstElementChild;
    
    if (firstChild && !firstChild.parentElement.matches('a')) {
      // Create the anchor
      const link = document.createElement('a');
      link.href = href;

      // Insert the link before the child
      wrapper.insertBefore(link, firstChild);

      // Move the child inside the link
      link.appendChild(firstChild);
    }
  });
}
/*----- Ends Add Link to Amazing Cookies Img in Footer -----*/

/*----- Executes functions on DOM Load -----*/
window.addEventListener('load', function() {
    console.log('DOM is loaded.');
    updateImageBannerText();
    wrapFooterImages("https://nanisweets.com/collections/amazing-cookies");
})
